import { useList } from "@inmagik/react-crud"
import { API_URL } from "../constants"
import { ClassificazioneOggetto } from "../types"

export function useClassOggettiList(params: Record<string, string | string[] | number[] | number> = {}) {
  return useList<ClassificazioneOggetto>(`${API_URL}/classificazioni-oggetti`, { query: params })
}
